var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessPremiumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 2,
    fill: "#D75F04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5319 37C74.2948 37 75.0492 37.1611 75.7456 37.4729C76.4419 37.7847 77.0646 38.24 77.5727 38.8092L77.8652 39.1667L87.8969 52.5431C88.6057 53.4881 88.9862 54.639 88.9803 55.8203C88.9744 57.0015 88.5825 58.1485 87.8644 59.0865L87.5719 59.4385L62.4954 87.0202C61.897 87.6788 61.0634 88.0753 60.1749 88.124C59.2864 88.1726 58.4144 87.8695 57.7477 87.2802L57.485 87.0202L32.4085 59.4358C31.6137 58.5615 31.1266 57.4512 31.0215 56.2742C30.9164 55.0973 31.199 53.9183 31.8262 52.9169L32.0835 52.5431L42.1152 39.1667C42.573 38.556 43.1547 38.0491 43.8221 37.6789C44.4896 37.3088 45.2277 37.0839 45.9881 37.019L46.4485 37H73.5319ZM66.8233 58.6667H53.1571L59.9902 75.7481L66.8233 58.6667ZM80.9527 58.6667H72.6571L66.1408 74.9573L80.9527 58.6667ZM47.3233 58.6667H39.0304L53.8396 74.9573L47.3233 58.6667ZM61.0248 42.4167H58.9556L53.5389 53.25H66.4414L61.0248 42.4167ZM73.5319 42.4167H67.0806L72.4973 53.25H81.6569L73.5319 42.4167ZM52.8998 42.4167H46.4485L38.3235 53.25H47.4831L52.8998 42.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessPremiumIcon);
export default __webpack_public_path__ + "static/media/access-premium-icon.e8296609b6708952f92a7200fc788543.svg";
export { ForwardRef as ReactComponent };